export default __webpack_public_path__ + "static/media/Dhaka_Resume_F2.1ec83851.pdf";